import { X as XpBgImg, g as _createForOfIteratorHelper, f as handleUrl, _ as _asyncToGenerator, r as regenerator } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import Vue from 'vue';
import { X as XpProgressBar } from './XpProgressBar.js';

var PageContainer = Vue.extend({
  name: 'PageContainer',
  components: {
    XpProgressBar: XpProgressBar,
    XpBgImg: XpBgImg
  },
  data: function data() {
    return {
      recordedTime: null,
      originalAllowNavAutoHide: null,
      pageRecTime: null,
      pageTime: null,
      offTime: null,
      onTime: null,
      lastTouchEnd: 0,
      showPreferredOrientationHint: true,
      showScreenReaderConfirmation: false,
      liked: false
    };
  },
  computed: {
    showNextPageLink: function showNextPageLink() {
      return this.$xp.history.nextPageId && this.$xp.content.pageData.Class !== 'XpSelectLanguage' && this.$xp.content.pageData.Class !== 'XpSplashScreen';
    },
    homeButtonEnabled: function homeButtonEnabled() {
      // if (this.$xp.content.pageData.Class === 'XpSelectLanguage') { return false }
      var isStartPage = this.$xp.content.pageData.ID === this.$xp.settings.mergedSettings.content.startPageID;

      if (!this.$xp.device.isLoan && isStartPage || this.$xp.device.isLoan && (isStartPage || !this.$xp.history.lastHomeEntry)) {
        return false;
      } else {
        return true;
      }
    },
    shareButtonEnabled: function shareButtonEnabled() {
      return this.$xp.content.pageData.canShare;
    },
    likeButtonEnabled: function likeButtonEnabled() {
      return this.$xp.content.pageData.canLike;
    }
  },
  created: function created() {
    var _this = this;

    this.$xp.screen.postponeDim(); // in leihgeraete ist der Topbar sichtbar beim navigieren von der AdminActivity

    if (!this.$xp.navigation.isNavHidden && this.$xp.content.pageData.Class === 'XpSplashScreen') {
      this.$xp.navigation.hideNav();
    }

    this.$xp.navigation.checkScreenReader().then(function (isScreenReader) {
      _this.isScreenReader = isScreenReader;
    });
    window.addEventListener('beforeunload', this.onBeforeUnload);
  },
  mounted: function mounted() {
    console.log('#*#*# PageContainer mounted [core]', this.$route.params.id);
    this.startVisitRecording();

    if (this.$xp.content.pageData.isStartPage) {
      window.localStorage.removeItem('nfcLangCode');
      window.localStorage.removeItem('nfcSelectedBranchIds');
      window.localStorage.removeItem('nfcPageId');
    }

    this.resetPreferredOrientationHint();
    this.$xp.cart.restoreCart(); // this.startWatchingTitleLength() // durchlaufender Seitentitel wird nicht mehr verwendet 20210510
  },
  updated: function updated() {// this.checkTitleHeight()
  },
  beforeDestroy: function beforeDestroy() {
    this.$xp.screen.cancelDimTimer();
    this.stopVisitRecording();
    this.$xp.settings.resetSettingsState();
    this.$xp.history.resetHistoryState(); // this.unwatchTitleLength()
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this2 = this;

    if (this.$xp.content.showPreloadModal) {
      this.$xp.content.showPreloadModal = false;
    }

    var activeElement = document.activeElement; // disable navigation bars animation temporary
    // .c-top-bar // transition: top .2s ease-in-out;
    // .c-page-container__back // transition: bottom .2s ease-in-out;

    if (activeElement) {
      var pageId = parseInt(from.params.id);
      var selector = this.$xp.navigation.getUniqueSelector(activeElement);
      console.log('beforeRouterUpdate() save selector: "', selector, '" of element:', activeElement, ', pageId', pageId);

      if (selector.datasavefocus) {
        this.$xp.history.setHistoryParam(pageId, 'focus', selector);
      }
    }

    !this.$xp.navigation.isChildPagesMenuHidden && this.$xp.navigation.toggleChildPagesMenu();
    Vue.nextTick(function () {
      _this2.$el.querySelector('.c-top-bar').style.transition = 'none';

      if (_this2.$el.querySelector('.c-page-container__back') !== null) {
        _this2.$el.querySelector('.c-page-container__back').style.transition = 'none';
      }

      setTimeout(function () {
        console.log('add top bar classes');
        _this2.$el.querySelector('.c-top-bar').style.transition = 'top .2s ease-in-out';

        if (_this2.$el.querySelector('.c-page-container__back') !== null) {
          // Animation nach unten gab Problem mit Scrollbar in Chrome. Deshalb nach link raus
          _this2.$el.querySelector('.c-page-container__back').style.transition = 'left .2s ease-in-out';
        }
      }, 500);
    });
    next();
  },
  methods: {
    getThumbnailWidth: function getThumbnailWidth() {
      var _iterator = _createForOfIteratorHelper(this.$xp.settings.mergedSettings.content.imageResolutions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var w = _step.value;
          return w;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    goBack: function goBack(e) {
      e.preventDefault();
      this.$xp.history.back();
    },
    showNavPermanent: function showNavPermanent(e) {
      var _this3 = this;

      this.$xp.navigation.isScreenReader = true;
      this.$xp.screen.exitFullscreen();
      this.$xp.navigation.showNav();
      setTimeout(function () {
        _this3.showScreenReaderConfirmation = true;
      }, 300);
      console.log('showNavPermanent() set isScreenReader');
      e.preventDefault();
    },
    startVisitRecording: function startVisitRecording() {
      this.$xp.evaInstalled && this.$xp.eva.startVisit();
      this.recordedTime = Date.now();
    },
    stopVisitRecording: function stopVisitRecording() {
      this.writePageRecord(this.$xp.history.historyArray[this.$xp.history.historyArray.length - 1].pageId);
      this.$xp.evaInstalled && this.$xp.eva.endVisit();
    },
    openShareMenu: function openShareMenu() {
      console.log('openShareMenu');

      if (navigator.share) {
        navigator.share({
          title: this.$xp.content.pageTitle,
          url: window.URL
        }).then(function () {
          console.log('Thanks for sharing!');
        }).catch(console.error);
      } else {
        console.log('Fallback');
      }
    },
    doLikeStuff: function doLikeStuff() {
      // console.log('LIKE!')
      if (this.$xp.cart.isInCart(this.$route.params.id)) {
        this.$xp.cart.removeFromCart(this.$route.params.id);
      } else {
        this.$xp.cart.addToCart(this.$route.params.id, this.$route.path, this.$xp.content.pageTitle);
      }

      this.$xp.content.liked = this.$xp.cart.isInCart(this.$route.params.id);
    },
    onBeforeUnload: function onBeforeUnload() {
      this.stopVisitRecording();
    },
    writePageRecord: function writePageRecord(pageId) {
      if (!pageId) {
        // PageRec is invalid
        return;
      }

      var pageRecord = {
        start: this.pageRecTime !== null ? this.pageRecTime : this.recordedTime,
        end: Date.now(),
        langcode: this.$xp.polyglot.locale,
        on: this.onTime !== null ? this.onTime : Date.now() - (this.pageTime !== null ? this.pageTime : this.pageRecTime !== null ? this.pageRecTime : this.recordedTime),
        off: this.offTime,
        pageid: pageId
      };

      if (isNaN(pageRecord.on) || pageRecord === null) {
        pageRecord.on = pageRecord.end - pageRecord.start;
      }

      this.$xp.evaInstalled && this.$xp.eva.addPage(pageRecord);
      console.log(pageRecord);
    },
    getIconClass: function getIconClass(pageClass) {
      switch (pageClass) {
        case 'XpMenu':
          return 'xp-home-menu';

        case 'XpNumericInput':
          return 'xp-numpad';

        case 'XpMap':
          return 'xp-map';

        case 'XpNfc':
          return 'xp-nfc';

        case 'XpPanorama':
          return 'xp-panorama';

        default:
          return pageClass.replace(/(Xp|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
      }
    },
    selectTab: function selectTab(tabId) {
      handleUrl(tabId, this.$router, true);
    },
    toggleHomeMenu: function toggleHomeMenu() {
      var _this4 = this;

      this.$xp.navigation.toggleHomeMenu();

      if (this.$xp.navigation.__isHomeMenuHidden) {
        // console.log('Homemenu WAS hidden')
        this.$nextTick();
        setTimeout(function () {
          _this4.$refs.openHomemenu.focus();
        }, 0);
      } else {
        // console.log('Homemenu WAS SHOWN')
        this.$nextTick();
        setTimeout(function () {
          _this4.$refs.closeHomemenu.focus();

          var oLastTabable = _this4.$el.querySelector('.c-page-container__home-menu__wrapper ul:last-child li:last-child a');

          oLastTabable && oLastTabable.addEventListener('keydown', function (e) {
            if (e.keyCode === 9 && !e.shiftKey) {
              e.preventDefault();
              document.querySelector('.c-page-container__home-menu__wrapper div.close button').focus();
            }
          });
        }, 0);
      }

      return false;
    },
    renderTabs: function renderTabs(h) {
      var _this5 = this;

      if (this.$xp.navigation.tabs.length < 2) {
        return null;
      }

      return h('div', {
        class: {
          'o-nav-tabs': true,
          'o-nav-tabs--hidden': this.$xp.navigation.isNavHidden
        }
      }, [this.$xp.navigation.tabs.map(function (item) {
        if (typeof item.ID === 'number' || !item.ID.includes('xpedeo://') || item.ID.includes('xpedeo://') && _this5.shouldRenderTab(item.ID)) {
          return h('div', {
            class: {
              'o-nav-tabs__tab': true,
              'is-active': _this5.isTabActive(item.ID)
            },
            key: item.ID
          }, [h('input', {
            attrs: {
              name: 'nav-tabs',
              type: 'radio',
              'aria-hidden': false,
              'aria-label': item.Title,
              value: "".concat(item.ID),
              id: "".concat(item.Title).concat(item.ID)
            },
            class: 'sr-only',
            domProps: {
              checked: _this5.isTabActive(item.ID)
            },
            on: {
              change: function change(e) {
                e.preventDefault();
                _this5.isTabActive(item.ID) ? console.log('tab is active') : _this5.selectTab(item.ID);
              }
            }
          }), h('label', {
            attrs: {
              for: "".concat(item.Title).concat(item.ID)
            },
            class: 'o-nav-tabs__tab-a'
          }, [h('span', {
            class: "xp xp--large ".concat(_this5.getIconClass(item.Class)),
            attrs: {
              'aria-hidden': true
            }
          })])]);
        } else {
          console.log('Store Tab will not be rendered, nothing in store & no default value');
          return null;
        }
      })]);
    },
    renderTopBar: function renderTopBar(h) {
      var _this6 = this;

      return h('div', {
        class: {
          'c-top-bar': true,
          'is-hidden': this.$xp.navigation.isNavHidden,
          'is-padded-for-nav': !this.$xp.content.pageData.isNavOverlapping
        },
        attrs: {
          'aria-hidden': !this.$xp.navigation.__isHomeMenuHidden,
          'aria-busy': this.$xp.http.isLoading
        }
      }, [h('div', {
        class: ['c-top-bar__nav-wrapper']
      }, [this.homeButtonEnabled ? h('button', {
        attrs: {
          'aria-expanded': !this.$xp.navigation.isHomeMenuHidden,
          'aria-label': this.$t('global.homeMenuBtnLabel')
        },
        ref: 'openHomemenu',
        class: {
          'c-top-bar__button': true,
          left: true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        on: {
          click: function click() {
            _this6.toggleHomeMenu();
          }
        }
      }, [h('span', {
        class: 'xp xp-menu xp--large link',
        attrs: {
          'aria-hidden': true
        }
      })]) : null, h('h1', {
        attrs: {
          id: 'pageTitle',
          tabindex: '-1'
        },
        class: 'c-top-bar__heading js-heading',
        ref: 'pageTitle'
      }, [h('span', {
        class: 'c-top-bar__heading-text js-heading-text'
      }, [this.$xp.content.pageTitle])]), // <button href="#" @click="$xp.navigation.toggleChildPagesMenu()" class="c-top-bar__button right" :aria-expanded="$xp.navigation.isChildPagesMenuHidden ? 'false':'true'" :aria-label="$t('global.openChildPagesMenu')" v-if="$xp.navigation.childPagesMenuItems.length > 0 && $xp.content.pageData.Class !== 'XpMenu'">
      //     <span class="xp xp-menu xp--large link"></span>
      // </button>
      this.$xp.navigation.childPagesMenuItems.length > 0 && this.$xp.content.pageData.Class !== 'XpMenu' && this.$xp.settings.mergedSettings.navigation.showChildPagesMenu ? h('button', {
        attrs: {
          href: '#',
          'aria-expanded': !this.$xp.navigation.isChildPagesMenuHidden,
          'aria-label': this.$t('global.openChildPagesMenu')
        },
        ref: 'openChildPagesMenu',
        class: {
          'c-top-bar__button': true,
          right: true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        on: {
          click: function click() {
            _this6.$xp.navigation.toggleChildPagesMenu();
          }
        }
      }, [h('span', {
        class: 'xp xp-more xp--large link'
      })]) : null])]);
    },
    // <div class="c-right-bar">
    // <button class="c-right-bar__button"><span class="xp xp-share xp--large link"></span></button>
    // <button class="c-right-bar__button"><span class="xp xp-like xp--large link"></span></button>
    // </div>
    renderRightBar: function renderRightBar(h) {
      var _this7 = this;

      return h('div', {
        class: {
          'c-right-bar': true,
          'is-hidden': this.$xp.navigation.isNavHidden
        }
      }, [this.shareButtonEnabled ? h('button', {
        class: {
          'c-right-bar__button': true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        on: {
          click: function click() {
            return _this7.openShareMenu();
          }
        }
      }, [h('span', {
        class: 'xp xp-share xp--large link'
      })]) : null, this.likeButtonEnabled ? h('button', {
        class: {
          'c-right-bar__button': true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        on: {
          click: function click() {
            _this7.doLikeStuff();
          }
        }
      }, [h('span', {
        class: {
          'xp xp--large link': true,
          'xp-like': this.$xp.content.liked,
          'xp-like-off': !this.$xp.content.liked
        }
      })]) : null]);
    },
    resetPreferredOrientationHint: function resetPreferredOrientationHint() {
      var _this8 = this;

      var preferredOrientationHintImg = this.$el ? this.$el.querySelector('img.c-page-container__orientation-hint') : null;

      if (preferredOrientationHintImg) {
        preferredOrientationHintImg.addEventListener('animationend', function () {
          console.log('preferredOrientationHintImg.animationend');
          _this8.showPreferredOrientationHint = false;
        });
      }
    },
    executeSettingsJs: function executeSettingsJs() {
      if (this.$xp.settings.mergedSettings.executejs) {
        console.log('Execute ExternalJs', this.$xp.settings.mergedSettings.executejs);

        for (var item in this.$xp.settings.mergedSettings.executejs) {
          console.log('Execute: ', item);

          try {
            this._jsexecuter.bind(self)(this.$xp.settings.mergedSettings.executejs[item]);
          } catch (e) {
            console.error('ERROR in external js', item, ':', e.message);
          }
        }
      }
    },
    _jsexecuter: function _jsexecuter(cCode) {
      // eslint-disable-next-line no-eval
      return eval(cCode);
    },
    checkTitleHeight: function checkTitleHeight() {
      console.log('CheckTitleHeight');

      if (!this.$xp.content.pageData.isNavOverlapping && this.$xp.content.pageData.Class !== 'XpPanorama') {
        console.log('--check');
        var nTitleHeight = document.getElementById('pageTitle').offsetHeight;
        var oContent = document.getElementById('page-content').getElementsByTagName('div')[0];

        if (oContent) {
          if (nTitleHeight > 50) {
            oContent.style.paddingTop = "calc(".concat(nTitleHeight, "px + 10px + var(--safe-area-inset-top))");
          } else {
            oContent.style.removeProperty('padding-top');
          }
        }
      }
    },
    startWatchingTitleLength: function startWatchingTitleLength() {
      var _this9 = this;

      // durchlaufender Seitentitel wird nicht mehr verwendet 20210510
      this.unwatchTitleLength = this.$watch(function (vm) {
        return [vm.$xp.content.pageTitle, vm.$xp.screen.orientation].join();
      }, function () {
        var span = _this9.$el.querySelector('.js-heading-text');

        span.classList.remove('c-top-bar__heading-text--marquee');
        setTimeout(function () {
          var heading = _this9.$el.querySelector('.js-heading');

          console.log(heading.offsetWidth, span.offsetWidth);

          if (heading.offsetWidth < span.offsetWidth) {
            console.log("overflowed by ".concat(heading.offsetWidth - span.offsetWidth, " px"));
            span.classList.add('c-top-bar__heading-text--marquee');
            var duration = Math.round(span.offsetWidth / 80, 1);
            span.style.animationDuration = duration + 's';
            var delay = Math.round(Math.min(span.offsetWidth / 500, (span.offsetWidth - heading.offsetWidth) / 160), 1);
            span.style.animationDelay = '-' + delay + 's';
          } else {
            span.classList.remove('c-top-bar__heading-text--marquee');
          }
        }, 200);
      });
    },
    shouldRenderTab: function shouldRenderTab(tabId) {
      if (typeof tabIdtab === 'string' && tabId.includes('LastPanoramaID')) {
        var lastPanoramaPageId = this.$xp.history.lastHomePage && this.$xp.history.getLastPanoramaPage(this.$xp.history.lastHomePage.pageId);
        var defaultPanoramaPageId = this.$xp.content.pageData.Homepage ? !!this.$xp.content.pageData.Homepage.DefaultPanoramaPageID : false;
        return lastPanoramaPageId || defaultPanoramaPageId;
      }

      return true;
    },
    isTabActive: function isTabActive(tabId) {
      var id = tabId;

      if (typeof id === 'string' && id.includes('LastPanoramaID')) {
        var lastPanoramaPageId = this.$xp.history.lastHomePage ? this.$xp.history.lastHomePage && this.$xp.history.getLastPanoramaPage(this.$xp.history.lastHomePage.pageId) : null;
        var defaultPanoramaPageId = this.$xp.content.pageData.Homepage ? this.$xp.content.pageData.Homepage.DefaultPanoramaPageID : null;
        id = lastPanoramaPageId || defaultPanoramaPageId;
      }

      return this.$xp.navigation.activeTabId === id;
    },
    setPseudoCoordination: function setPseudoCoordination() {
      if (this.$xp.content.pageData.PseudoCoordinates && this.$xp.positioningInstalled) {
        var pseudoEngine = this.$xp.positioning.getEngine('Pseudo');
        console.log('set PseudoCoordinates: ', this.$xp.content.pageData.PseudoCoordinates);
        pseudoEngine && pseudoEngine.setPseudoCoordination(this.$xp.content.pageData.PseudoCoordinates);
      }
    }
  },
  watch: {
    '$xp.navigation.__isChildPagesMenuHidden': {
      handler: function handler() {
        var _this10 = this;

        // Hier Watcher, weil Contextmenu auch in Video/Audio ausgeloest werden kann
        // console.log('WATCHER', 'ChildPagesHidden', this.$xp.navigation.__isChildPagesMenuHidden, newValue, oldValue)
        if (this.$xp.navigation.__isChildPagesMenuHidden) {
          // console.log('Childpagesmenu is hidden')
          this.$nextTick();
          setTimeout(function () {
            _this10.$refs.openChildPagesMenu.focus();
          }, 0);
        } else {
          this.$nextTick();
          setTimeout(function () {
            _this10.$refs.closeChildPagesMenu.focus();

            var oLastTabable = _this10.$el.querySelector('.c-page-container__child-pages__wrapper ul:last-child li:last-child a');

            oLastTabable.addEventListener('keydown', function (e) {
              if (e.keyCode === 9 && !e.shiftKey) {
                e.preventDefault();
                document.querySelector('.c-page-container__child-pages__wrapper div.close button').focus();
              }
            });
          }, 0);
        }
      }
    },
    '$xp.screen.isIdle': {
      handler: function handler(newValue) {
        // console.log('oldvalue', oldValue, 'newValue', newValue)
        if (newValue === true) {
          if (this.onTime === null) {
            this.onTime = Date.now() - this.pageTime;
          } else {
            this.onTime += Date.now() - this.pageTime;
          }

          if (this.offTime === null) {
            this.offTime = 0;
          }

          this.pageTime = Date.now();
        }

        if (newValue === false) {
          if (this.offTime === null) {
            this.offTime = Date.now() - this.pageTime;
          } else {
            this.offTime += Date.now() - this.pageTime;
          }

          if (this.onTime === null) {
            this.onTime = 0;
          }

          this.pageTime = Date.now();
        }
      }
    },
    '$xp.screen.orientation': {
      handler: function handler() {
        var _this11 = this;

        this.showPreferredOrientationHint = true;
        setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this11.$nextTick();

                case 2:
                  _this11.checkTitleHeight();

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })), 0); // Dies wird vor dem Rendern aufgerufen; deshalb später das Event auf animationend setzen

        setTimeout(function () {
          _this11.resetPreferredOrientationHint();
        }, 500);
      }
    },
    '$xp.content.pageData.Settings': {
      handler: function handler(newValue) {
        if (newValue && newValue.executejs) {
          this.executeSettingsJs();
        }
      }
    },
    '$xp.content.pageTitle': {
      handler: function handler(newValue) {
        var _this12 = this;

        // console.log(document.title)
        // console.log(this.$refs['title'])
        // write page record
        this.writePageRecord(this.$route.params.id);
        this.onTime = null;
        this.offTime = null;
        this.pageTime = this.pageRecTime = Date.now();

        if (newValue !== undefined) {
          if (this.$xp.device.platform === 'ios') {
            if (window.StatusBar && window.StatusBar.isVisible) {
              window.StatusBar.hide();
              console.log('is it not responding ?');
            }

            console.log('statusbar', window.StatusBar);
            console.log('visibility', window.StatusBar.isVisible);
          } // console.log(newValue)

        }

        this.setPseudoCoordination(); // if (this.$xp.tracker) {
        //   this.$xp.tracker.update()
        // }

        this.showScreenReaderConfirmation = false;
        if (this.$xp.navigation.isScreenReader) this.$xp.navigation.showNav();
        setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this12.$nextTick();

                case 2:
                  _this12.checkTitleHeight();

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })), 0);
      },
      immediate: true
    },
    '$xp.navigation.isNavHidden': {
      handler: function handler(value) {
        if (value === true) {
          !this.$xp.navigation.isChildPagesMenuHidden && this.$xp.navigation.toggleChildPagesMenu();
        }
      }
    },
    '$xp.navigation.isChildPagesMenuHidden': function $xpNavigationIsChildPagesMenuHidden(v) {
      if (this.originalAllowNavAutoHide === null) {
        this.originalAllowNavAutoHide = this.$xp.navigation.isAutoHideAllowed;
      }

      if (!v && this.originalAllowNavAutoHide) {
        this.$xp.navigation.preventAutoHide();
        this.$xp.navigation.showNav();
      } else {
        if (this.originalAllowNavAutoHide) {
          this.$xp.navigation.allowAutoHide();
          this.$xp.navigation.showNav(500);
        }

        this.originalAllowNavAutoHide = null;
      }

      this.$xp.history.setHistoryParam(this.$route.params.id, 'lastChildPagesState', v);
    },
    '$xp.settings.mergedSettings.exitAppNow': {
      handler: function handler(v) {
        console.log('exit app now');

        if (v && this.$xp.device.platform === 'android') {
          window.XpedeoPreloader.disableKioskAndExit();
        }
      }
    }
  },
  render: function render(h) {
    var _this13 = this;

    return h('div', {
      class: ['c-page-container', this.$xp.content.pageData.BgImage && this.$xp.content.pageData.BgImage.BinaryID ? 'has-bgimg' : '', this.$xp.content.pageData.CurrentPageSettings && this.$xp.content.pageData.CurrentPageSettings.additionalPageContainerClasses ? this.$xp.content.pageData.CurrentPageSettings.additionalPageContainerClasses : ''],
      style: this.$xp.content.pageData.BgImage && this.$xp.content.pageData.BgImage.BinaryID ? 'background-image: url(' + this.$xp.content.getImageUrl(this.$xp.content.pageData.BgImage) + ');' : ''
    }, [// <a href="#" v-if="$xp.navigation.isAutoHideAllowed" id="show-nav-permanent" class="sr-only sr-only-focusable" @click.prevent="showNavPermanent()" role="button"></a>
    // The message global.srShowNavigationConfirmed shall only be shown, wenn just switched to screen reader mode but not when activated earlier
    !this.$xp.navigation.isScreenReader && this.$xp.navigation.isAutoHideAllowed ? h('a', {
      attrs: {
        id: 'show-nav-permanent',
        href: '#',
        role: 'button'
      },
      class: 'sr-only sr-only-focusable',
      on: {
        click: function click(e) {
          _this13.showNavPermanent(e);
        }
      }
    }, [this.$t('global.srShowNavigation')]) : this.showScreenReaderConfirmation ? h('span', {
      attrs: {
        id: 'show-nav-permanent-confirmation',
        'aria-live': 'polite',
        role: 'alert',
        tabIndex: 0
      },
      class: 'sr-only sr-only-focusable'
    }, [this.$t('global.srShowNavigationConfirmed')]) : null, this.renderTopBar(h), this.renderRightBar(h), // <div role="main" :class="{'c-page-container__content': true, 'js-page-content': true}">
    //   <dynamic-page :key="$route.fullPath" :pageData="$xp.content.pageData"></dynamic-page>
    // </div>
    h('div', {
      attrs: {
        role: 'main',
        id: 'page-content',
        'aria-hidden': !this.$xp.navigation.__isHomeMenuHidden,
        'aria-busy': this.$xp.http.isLoading
      },
      class: {
        'c-page-container__content': true,
        'js-page-content': true
      }
    }, [h('dynamic-page', {
      props: {
        pageData: this.$xp.content.pageData
      }
    })]), this.renderTabs(h), this.showPreferredOrientationHint && this.$xp.device.isTouchDevice && this.$xp.content.pageData.PreferredOrientation && this.$xp.screen.orientation && this.$xp.content.pageData.PreferredOrientation !== this.$xp.screen.orientation.replace(/-.+$/, '') ? h('img', {
      attrs: {
        src: 'data:image/svg+xml;base64,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',
        'aria-hidden': 'true'
      },
      class: {
        'c-page-container__orientation-hint': true,
        animated: true
      },
      on: {
        click: function click() {
          _this13.showPreferredOrientationHint = false;
        }
      }
    }, []) : null, // <a href="#" :aria-label="$t('global.back')" v-show="$xp.history.historyArray.length > 1" :class="$xp.navigation.isNavHidden ? 'c-page-container__back is-hidden':'c-page-container__back'" @click.prevent="goBack" tabindex="0">
    //   <span class="xp xp-arrow-back xp--large link"></span>
    // </a>
    this.$xp.history.historyArray.length > 1 ? h('a', {
      attrs: {
        href: '#',
        'aria-label': this.$t('global.back'),
        tabindex: 0,
        'aria-hidden': !this.$xp.navigation.__isHomeMenuHidden
      },
      class: {
        'c-page-container__back': true,
        'is-hidden': this.$xp.navigation.isNavHidden
      },
      on: {
        click: this.goBack
      }
    }, [h('span', {
      class: 'xp xp-arrow-back xp--large link'
    })]) : null, // <router-link tag="button" :aria-label="$t('global.nextPageBtnLabel')" :class="$xp.navigation.isNavHidden ? 'c-top-bar__button right is-hidden' : 'c-top-bar__button right'" role="link" v-show="showNextPageLink" :to="'/page/' + $xp.history.nextPageId">
    //   <span class="xp xp-arrow-forward xp--large link"></span>
    // </router-link>
    this.showNextPageLink ? h('router-link', {
      attrs: {
        'aria-label': this.$t('global.nextPageBtnLabel'),
        role: 'link'
      },
      class: {
        'c-page-container__forward': true,
        right: true,
        'is-hidden': this.$xp.navigation.isNavHidden
      },
      props: {
        tag: 'button',
        to: "/page/".concat(this.$xp.history.nextPageId)
      }
    }, [h('span', {
      class: 'xp xp-arrow-forward xp--large link'
    })]) : null, // <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight" :duration="200">
    //   <div class="c-page-container__child-pages" v-if="!$xp.navigation.isChildPagesMenuHidden" @blur="$xp.navigation.toggleChildPagesMenu()">
    //     <ul>
    //       <router-link tag="li" :to="'/page/' + item.id" v-for="item in $xp.navigation.childPagesMenuItems" :key="item.id">
    //         {{ item.title }}
    //       </router-link>
    //     </ul>
    //   </div>
    // </transition>
    this.$xp.settings.mergedSettings.navigation.showChildPagesMenu ? h('transition', // { raus wegen Problemen mit anderen, gleichzeitigen Animationen, z.B. Panorama (siehe  _components.page-container.scss@18 )
    //   //  props: { 'enter-active-class': 'animated fadeInRight', 'leave-active-class': 'animated fadeOutRight', duration: 100 },
    //  attrs: { style: { 'animation-duration': '.1s' }
    // } },
    [!this.$xp.navigation.isChildPagesMenuHidden ? h('div', {
      class: 'c-page-container__child-pages ' + this.$xp.screen.orientation,
      on: {
        click: function click() {
          !_this13.$xp.navigation.isChildPagesMenuHidden && _this13.$xp.navigation.toggleChildPagesMenu();
        }
      }
    }, [h('div', {
      class: 'c-page-container__child-pages__wrapper ' + this.$xp.screen.orientation
    }, [h('div', {
      class: 'close'
    }, [h('button', {
      attrs: {
        tabindex: '0',
        title: this.$t('global.closeChildPagesMenu')
      },
      ref: 'closeChildPagesMenu',
      on: {
        click: function click() {
          _this13.$xp.navigation.toggleChildPagesMenu();
        }
      }
    }, [h('span', {
      class: 'xp xp--large xp-close',
      attrs: {
        'aria-hidden': true
      }
    })])]), h('ul', {
      class: !this.$xp.navigation.childPagesHaveIcons ? 'no-icons' : null
    }, this.$xp.navigation.childPagesMenuItems.map(function (item) {
      return h('li', {}, [h('router-link', {
        props: {
          to: '/page/' + item.id
        },
        class: 'c-page-container__child-pages__item'
      }, [item.icon && item.icon.Type === 'binary' ? h('xp-bg-img', {
        props: {
          tag: 'div',
          src: _this13.$xp.content.getImageUrl(item.icon.Image, _this13.getThumbnailWidth()),
          placeholderSrc: item.icon.Image.Thumb,
          dataBinarySrc: item.icon.Image.src,
          lazyload: false
        },
        class: 'c-page-container__child-pages__item-imagewrapper'
      }) : h('span', {
        class: 'xp xp--large ' + (item.icon ? item.icon.ID : 'xp-space'),
        attrs: {
          'aria-hidden': 'true'
        }
      }), h('div', {
        class: 'c-page-container__child-pages__item-textwrapper'
      }, [item.title])])]);
    }))])]) : null]) : null, // <transition enter-active-class="animated fadeInLeft" leave-active-class="animated fadeOutLeft" :duration="100">
    //   <div class="c-page-container__home-menu" v-if="!$xp.navigation.isHomeMenuHidden" @blur="$xp.navigation.toggleHomeMenu()">
    //     <div>blub</div>
    //   </div>
    // </transition>
    h('transition', {
      props: {
        'enter-active-class': 'animated fadeInLeft',
        'leave-active-class': 'animated fadeOutLeft',
        duration: 100
      },
      attrs: {
        style: {
          'animation-duration': '.1s'
        }
      }
    }, [!this.$xp.navigation.__isHomeMenuHidden ? h('div', {
      class: 'c-page-container__home-menu',
      on: {
        click: function click() {
          !_this13.$xp.navigation.isHomeMenuHidden && _this13.$xp.navigation.toggleHomeMenu();
        }
      }
    }, [h('div', {
      class: 'c-page-container__home-menu__wrapper ' + this.$xp.screen.orientation
    }, [h('div', {
      class: 'close'
    }, [h('button', {
      attrs: {
        tabindex: '0',
        title: this.$t('global.homeMenuCloseLabel')
      },
      ref: 'closeHomemenu',
      on: {
        click: function click() {
          _this13.toggleHomeMenu();
        }
      }
    }, [h('span', {
      class: 'xp xp--large xp-close',
      attrs: {
        'aria-hidden': 'true'
      }
    })])]), h('ul', {
      class: 'history',
      attrs: {
        'aria-label': this.$t('global.navigationsPfad')
      }
    }, [this.$xp.history.homepagesList.length > 0 ? this.$xp.history.homepagesList.map(function (item, i) {
      return h('li', {}, [h('router-link', {
        props: {
          to: item.path
        },
        key: item.id
      }, [h('span', {
        class: 'xp xp--large ' + (i === 0 ? 'xp-house' : 'xp-chevron-up'),
        attrs: {
          'aria-hidden': 'true'
        }
      }), item.title])]);
    }) : h('li', {}, [h('router-link', {
      props: {
        to: '/_/page/' + this.$xp.settings.mergedSettings.content.startPageID
      }
    }, [h('span', {
      class: 'xp xp--large xp-house',
      attrs: {
        'aria-hidden': 'true'
      }
    }), 'Home'])])]), h('ul', {
      class: 'other',
      attrs: {
        'aria-label': this.$t('global.redactionalLinks')
      }
    }, [this.$xp.settings.mergedSettings.menu ? this.$xp.settings.mergedSettings.menu.map(function (item) {
      return h('li', {}, [h('router-link', {
        props: {
          to: '/page/' + item.PageID
        },
        class: 'c-page-container__home-menu__item'
      }, [item.Icon && item.Icon.Type === 'binary' ? h('xp-bg-img', {
        props: {
          tag: 'div',
          src: _this13.$xp.content.getImageUrl(item.Icon.Image, _this13.getThumbnailWidth()),
          placeholderSrc: item.Icon.Image.Thumb,
          dataBinarySrc: item.Icon.Image.src,
          lazyload: false
        },
        class: 'c-page-container__home-menu__item-imagewrapper'
      }) : h('span', {
        class: 'xp xp--large ' + (item.Icon ? item.Icon.ID : 'xp-space'),
        attrs: {
          'aria-hidden': 'true'
        }
      }), item.Title])]);
    }) : null])])]) : null]), // progress bar infinite animation causing problems with TalkBack.
    // Therfore, it should be removed from DOM when it's not needed
    this.$xp.http.isLoading ? h('xp-progress-bar', {
      attrs: {
        'aria-live': 'assertive'
      },
      props: {
        value: this.$xp.http.progressValue
      },
      class: {
        'c-page-container__progress': true // 'c-page-container__progress--hidden': !this.$xp.http.isLoading

      }
    }) : null]);
  }
});

export default PageContainer;
//# sourceMappingURL=PageContainer.js.map
